import { ContentType, Method } from "axios-mapper";
import https from "../utils/https";

export const getConfigByCode = (code, siteId) => {
  return https().request('/config/search-by-code', Method.GET, { code, siteId }, ContentType.form);
};
